export const requirementsMapping: any = {
  "owner-representative-form": "Formulario del Representante del Propietario",
  "authorization-letter": "Carta Autorización",
  "business-short-form": "Formulario de la Empresa",
  "guarantor-cja-form": "Formulario del Obligado Solidario",
  "business-cja-form": "Formulario de la Empresa",
  "legal-rep-short-form": "Formulario del Representante Legal",
  "tenant-cja-form": "Formulario del Inquilino",
  "tax-status-certificate": "Constancia de Situación Fiscal",
  "business-form-lease-contract": "Formulario de la Empresa (contrato)",
  "escrituras-predial": "Escrituras o Predial del inmueble en renta",
  "lease-contract-form": "Datos de la renta y contrato",
  "landlord-form": "Formulario del Propietario",
  predial: "Predial del inmueble en garantía",
  "boleta-registral": "Boleta registral con folio real",
  "guarantor-form": "Formulario del Obligado Solidario",
  "sat-compliance": "Opinión de cumplimiento del SAT",
  "power-of-attorney": "Poder del representante legal",
  "bdc-company-data": "Datos de la Empresa para Buró de Crédito",
  "business-form": "Formulario de la Empresa",
  "constitutive-act": "Acta constitutiva de la empresa",
  "commercial-references": "Referencias Comerciales",
  "legal-rep-form": "Formulario del Representante Legal",
  "digital-signature": "Firma Autógrafa Digital",
  "bdc-authorization": "Autorización digital de consulta a Buró de Crédito",
  "personal-references": "Referencias Personales",
  "tenant-form": "Formulario del Inquilino",
  "proof-of-income": "Comprobante de Ingresos",
  "proof-of-address": "Comprobante de Domicilio",
  "official-id": "Identificación Oficial",
};
